<template>
<div>
  <div class="tab-pane in active">
    <h4><strong>Mini Baccarat</strong></h4>
    <p>TECHPLAY cung cấp trò chơi Mini Baccarat, các cửa cược như trò Baccarat bình thường, kết quả được xác định bởi luật chơi dưới đây và hệ thống chia bài ngẫu nhiên tự động đảm bảo tính công bằng cho mọi người chơi.</p>
    <p>Có 3 cửa chính để người chơi đặt tiền cược vào: Người chơi, Nhà cái và Hòa. Bên cạnh đó còn có một số ô cược phụ. Tùy thuộc vào điểm số, mỗi bên sẽ giữ nguyên hai lá bài ban đầu hoặc rút thêm lá bài thứ 3. Mỗi bên sẽ được chia tối đa 3 lá bài. Bên nào có điểm số gần 9 nhất thì thắng.</p>
    <p>Các loại cược của Baccarat bao gồm: </p>
    <ul>
      <li>Cược "Người chơi" / "Nhà Cái" / Hoà</li>
      <li>Cược “Đôi người chơi” và “Đôi nhà cái”</li>
      <!-- <li>Cược tổng điểm Tài/Xỉu</li>
      <li>Cược tổng điểm Lẻ/Chẵn</li> -->
    </ul>
    <p><strong>Lưu ý:</strong> </p>
    <p> - Cược "Người chơi" / "Nhà Cái" / Hoà: khi kết quả "Hoà" thì cửa đặt "Ngươi chơi" & "Nhà cái" hoàn tiền</p>
    <p>Sau một thời gian kéo dài, nếu không có kết quả chính thức, TECHPLAY có quyền hủy hoặc vô hiệu hoá
      các lượt rút đó hoặc tuyên bố hủy hiệu lực đối với các ván chơi hoặc lượt rút cụ thể nếu kết quả
      được công bố trước khi hệ thống ngưng nhận cược.</p>
    <ol>
      <li>
        <h5 class="color-white">Cược "Người chơi" / "Nhà Cái" / Hoà</h5>
        <p>TECHPLAY sẽ cung cấp tỉ lệ cược tương ứng và kết quả Baccarat là "Người chơi" / "Nhà Cái" / "Hoà"</p>
        <p>Ví dụ: Kết quả Baccarat: "Người chơi" là "7", "Nhà Cái" là "5". Vì "5" nhỏ hơn "7" do đó cược "Người chơi" chiến thắng. Nếu kết quả Baccarat là "Hoà" thì các cược "Người Chơi", "Nhà cái" hoàn tiền.</p>
      </li>
      <li>
        <h5 class="color-white">Cược đôi</h5>
        <p>"Đôi người chơi" là cược thắng khi 2 lá đầu tiên của người chơi là đôi</p>
        <p>"Đôi nhà cái" là cược chiến thắng khi 2 lá đầu tiên của nhà cái là đôi</p>
      </li>
    </ol>
  </div>

  <div>
    <h4><strong>Xóc dĩa</strong></h4>
    <p>
      Xóc Dĩa được chơi theo kết quả ngẫu nhiên được rút ra được từ 4 phần khác nhau với mỗi phần chứa hai nút (Đỏ và Trắng) theo thứ tự ngẫu nhiên.
    </p>
    <p>
      Tất cả kết quả được tạo bởi hệ thống RNG cam kết ngẫu nhiên và công bằng. Chúng tôi game Xóc dĩa có thời gian chờ là 30 giây.
    </p>
    <p>
      Các loại Cược cho Xóc dĩa là:
    </p>
    <ol class="c">
      <li>
        <h5 class="color-white">Kết quả Xóc dĩa</h5>
        <ol class="k">
          <li>Chúng tôi sẽ cung cấp các tỷ lệ ăn khác nhau dựa vào kết quả rút ra, được tính là “Kết quả Xóc dĩa”
            <ol class="n">
              <li>Kết quả bốn nút trắng</li>
              <li>Kết quả ba trắng và một đỏ</li>
              <li>Kết quả một trắng và ba đỏ</li>
              <li>Kết quả bốn nút đỏ</li>
              <li>Kết quả 2 nút trắng, 2 nút đỏ</li>
            </ol>
          </li>
          <li>Ví dụ: Thứ tự nút được rút là đỏ , đỏ , trắng , đỏ. Tổng số Đỏ là 3 và số Trắng là 1, cược “Một Trắng Ba Đỏ” chiến thắng</li>
        </ol>
      </li>
      <li>
        <h5 class="color-white">Lẻ / Chẵn</h5>
        <ol class="k">
          <li>Chúng tôi sẽ lấy số lẻ trên kết quả rút ra được làm “Lẻ” hoặc “Chẵn”.
            <ol class="n">
              <li>Lẻ – Kết quả của số nút trắng hoặc đỏ là một số lẻ</li>
              <li>Chẵn – Kết quả của số nút trắng hoặc đỏ là một số chẵn</li>
            </ol>
          </li>
          <li>Ví dụ: Thứ tự nút được rút là đỏ , đỏ , trắng , đỏ. Tổng số Đỏ là 3 và số Trắng là 1, cược “Lẻ” chiến thắng</li>
        </ol>
      </li>
    </ol>
    <p>
      Chúng tôi có quyền hủy hoặc vô hiệu hóa đối với mọi lượt rút có sự tác động khi không thể lấy được bất kỳ kết quả rút chính thức nào trong khoảng thời gian kéo dài hoặc khi có kết quả rút chính thức bất kỳ được công bố trước khi hệ thống ngưng nhận cược.
    </p>

  </div>

  <div>
    <h4><strong>Tài xỉu</strong></h4>
    <p>
      Tài Xỉu được chơi theo kết quả rút ra được từ 3 xúc xắc. Các kết quả được tạo bởi hệ thống RNG cam kết ngẫu nhiên và công bằng.
    </p>
    <p>
      Chúng tôi cung cấp game Tài Xỉu có thời gian chờ là 30 giây.
    </p>
    <p>
      Các loại cược dành cho Tài Xỉu là:
    </p>
    <ol class="c">
      <li>
        <h5 class="color-white">Tổng Tài/Xỉu</h5>
        <ol class="k">
          <li>Tổng Tài / Xỉu là cược vào tổng của 3 xúc xắc. Tổng sẽ nằm trong khoảng từ 3 đến 18</li>
          <li>“Tài” là cược chiến thắng nếu tổng của 3 xúc xắc nằm trong khoảng từ 11 đến 18</li>
          <li>“Xỉu” là cược chiến thắng nếu tổng của 3 xúc xắc nằm trong khoảng từ 3 đến 10</li>
        </ol>
      </li>
      <li>
        <h5 class="color-white">Cược số</h5>
        <ol class="k">
          <li>Cược số là dự đoán số cụ thể sẽ xuất hiện trên 3 xúc xắc</li>
          <li>Ví dụ: Kết quả Tài Xỉu: 1, 1, 3. Do đó, các cược vào “1” và “3” chiến thắng. Cược vào “1” sẽ thắng thêm 1 lần tiền cược do xuất hiện hai lần.</li>
        </ol>
      </li>
    </ol>
    <p>
      Sau một thời gian kéo dài, nếu không có kết quả chính thức, chúng tôi có quyền hủy hoặc vô hiệu hoá các lượt rút đó hoặc tuyên bố hủy hiệu lực đối với các ván chơi hoặc lượt rút cụ thể nếu kết quả được công bố trước khi hệ thống ngưng nhận cược.
    </p>

  </div>
</div>
</template>

<script>

export default {

}
</script>

<style>
ol.a {list-style-type: armenian;}
ol.b {list-style-type: cjk-ideographic;}
ol.c {list-style-type: decimal;}
ol.d {list-style-type: decimal-leading-zero;}
ol.e {list-style-type: georgian;}
ol.f {list-style-type: hebrew;}
ol.g {list-style-type: hiragana;}
ol.h {list-style-type: hiragana-iroha;}
ol.i {list-style-type: katakana;}
ol.j {list-style-type: katakana-iroha;}
ol.k {list-style-type: lower-alpha;}
ol.l {list-style-type: lower-greek;}
ol.m {list-style-type: lower-latin;}
ol.n {list-style-type: lower-roman;}
ol.o {list-style-type: upper-alpha;}
ol.p {list-style-type: upper-latin;}
ol.q {list-style-type: upper-roman;}
ol.r {list-style-type: none;}
ol.s {list-style-type: inherit;}
</style>
